module.exports = __webpack_public_path__ + "static/media/Rural.2cee8968.jpg";